import { trackError } from '@billy/track-error'
import { useMutation, useQueryClient } from 'react-query'

import { unregisterForEInvoicing } from '@features/attachments/query-api'
import { useUserOrganization } from '@modules-deprecated/app/organization'

import { QueryKeys } from '../../../enums/queryKeys'

export const useDisableNemhandel = () => {
  const { organization } = useUserOrganization()
  const queryClient = useQueryClient()

  const { mutateAsync, isLoading } = useMutation(
    () => {
      if (!organization?.id) {
        const errorMessage = 'Organization ID is required to disable Nemhandel'
        trackError(errorMessage)
        return Promise.reject(new Error(errorMessage))
      }

      return unregisterForEInvoicing({
        organizationId: organization.id,
      })
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(QueryKeys.RegisteredForEInvoicing)
      },
    },
  )

  return {
    disableNemhandel: mutateAsync,
    isProcessing: isLoading,
  }
}
